import { gql } from "@apollo/client";export default gql`query question($id: Int!) {
    question: question_by_pk(id: $id) {
        id
        text
        options
        correct_option
    }
}
`;
